<template>
  <div class="edit-follow-button">
    <!-- Contentタブ -->
    <div v-if="showTabContent">
      <ul>
        <draggable v-model="followButtonItems" draggable=".sns-icon-content" :group="'snsIcon'" handle=".sns-handle">
          <sns-icon-content
            v-for="followButtonItem in followButtonItems"
            :key="followButtonItem.table_id"
            :sectionId="sectionId"
            :partsContainerId="partsContainerId"
            :partsContainerType="partsContainerType"
            :partId="followButtonItem.id"
            :attrs="followButtonItem.attrs"
            :partsLength="followButtonItems.length"
            :partExistsSns="[]"
          />
        </draggable>
      </ul>
      <!-- SNS追加 -->
      <div v-if="showAddSnsButton">
        <div class="flex">
          <select-box
            :value="addSns"
            @updateValue="updateValue($event)"
          />
          <button
            type="button"
            @click="addSnsButton()"
            class="w-b-btn"
          >
            追加
          </button>
        </div>
      </div>
    </div>
    <!-- Styleタブ -->
    <div v-if="showTabStyle">
      <!-- ボックスのスタイル -->
      <follow-button-container-style
        :styles="containerStyles"
        :sectionId="sectionId"
        :partsContainerId="partsContainerId"
      />
      <!-- テキストのスタイル -->
      <follow-button-text-style
        :value="parts[0].styles"
        :sectionId="sectionId"
        :partsContainerId="partsContainerId"
        :partId="parts[0].id"
      />
    </div>
    <!-- 設定タブ -->
    <div v-if="showTabSetting">
      <!-- レイアウト -->
      <follow-button-layout
        :displaySns="parts[0].attrs['data-display-sns']"
        :sectionId="sectionId"
        :partsContainerId="partsContainerId"
        :partId="parts[0].id"
        :align="partsContainerAlign"
        :layoutType="partsContainerLayoutType"
        :iconSize="parts[0].attrs['width']"
        :srcType="partsContainer.src_type"
        :firstSnsName="parts[0].attrs['data-sns-name']"
        :partsContainerType="partsContainerType"
      />
      <!-- パーツの背景色 -->
      <edit-parts-container-style
        :styles="styles"
        :sectionId="sectionId"
        :partsContainerId="partsContainerId"
        :partsContainerType="partsContainerType"
      />
    </div>
  </div>
</template>

<script>
import SnsIconPartBase from '@/mixins/SnsIconPartBase'
import EditPartsContainerStyle from '@/components/Content/Palette/EditPartDesign/Layouts/PartsContainerStyle'
import SnsIconContent from '@/components/Content/Palette/EditPartDesign/Layouts/ContentTab/SnsIconContent'
import FollowButtonLayout from '@/components/Content/Palette/EditPartDesign/Layouts/SettingTab/SnsIconLayout'
import FollowButtonContainerStyle from '@/components/Content/Palette/EditPartDesign/Editor/FollowButton/FollowButtonContainerStyle'
import FollowButtonTextStyle from '@/components/Content/Palette/EditPartDesign/Layouts/StyleTab/TextStyle'
import SelectBox from '@/components/Content/Palette/CommonLayouts/EditSnsSelectBox'
import FollowButtonBase from '@/components/Content/Palette/EditPartDesign/Editor/FollowButton/FollowButtonBase'
import Draggable from 'vuedraggable'

const MAX_SNS_PART = 10

export default {
  props: [
    'current',
    'partsContainer',
    'parts',
    'sectionId',
    'partsContainerId',
    'partsContainerType',
    'styles',
  ],
  mixins: [
    FollowButtonBase,
    SnsIconPartBase,
  ],
  components: {
    EditPartsContainerStyle,
    SnsIconContent,
    FollowButtonLayout,
    FollowButtonContainerStyle,
    FollowButtonTextStyle,
    SelectBox,
    Draggable,
  },
  data () {
    return {
      addSns: 'Website',
    }
  },
  computed: {
    followButtonItems: {
      get () {
        return this.parts
      },
      set (value) {
        this.$store.commit('sortSnsIcon', {
          sectionId: this.sectionId,
          partsContainerId: this.partsContainerId,
          parts: value,
        })
      }
    },
    showTabContent () {
      return this.current.tab === 'Content'
    },
    showTabStyle () {
      return this.current.tab === 'Style'
    },
    showTabSetting () {
      return this.current.tab === 'Setting'
    },
    showAddSnsButton () {
      return this.parts.length < MAX_SNS_PART
    }
  },
  methods: {
    addSnsButton () {
      // mixinの処理からattrs取得
      const newSnsIcon = this.getSnsIconDefaultAttrs(this.addSns)
      if (!newSnsIcon) return
      this.$store.commit('addSnsIcon', {
        sectionId: this.sectionId,
        partsContainerId: this.partsContainerId,
        newSnsIcon: newSnsIcon,
      })
    },
    updateValue (sns) {
      this.addSns = sns
    },
  },
}
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
  align-items: center;
  margin: 20px;
  button {
    margin-left: 10px;
  }
}
</style>

<style lang="scss">
.edit-follow-button {
  .style-tab-text-style {
    .editor-design {
      .edit-style-select-color {
        // テキスト文字色のカラーピッカー
        .window {
          left: 0;
        }
      }
    }
  }
}
</style>
